export default __webpack_public_path__ + "fonts/select-down-arrow.svg";